module.exports = __webpack_public_path__ + "img/quest_finish.b6695d3b.svg";